import { cookieManager } from '../../services/cookies';
import { APP_MODE_ID, APP_MODE_PARAM } from '../../constants/common';
import { getLSValue } from '../../utils/locale-storage';

export const checkIsComplianceMode = () =>
  (cookieManager.readCookie(APP_MODE_PARAM) || (getLSValue(APP_MODE_PARAM) as string) || '') !== APP_MODE_ID;
